import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';

export default class Error404View extends View {
	get template() {
		return template;
	}

	get className() {
		return 'error-404-page';
	}

}